/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
const isLocalDev = !!process.env.LOCAL_DEV;
const widgetBaseURL = isLocalDev ? './' : process.env.WIDGET_PUBLIC_URL;
const widgetURL = `${widgetBaseURL}widget.js`;

export function createWidgetScript() {
  (function (theWindow, theDocument, scriptTag, instanceName, scriptSource) {
    theWindow[instanceName] =
      theWindow[instanceName] ||
      function () {
        (theWindow[instanceName].q = theWindow[instanceName].q || []).push(arguments);
      };
    const js = theDocument.createElement(scriptTag);
    const fjs = theDocument.getElementsByTagName(scriptTag)[0];
    js.id = instanceName;
    js.src = scriptSource;
    fjs.parentNode.insertBefore(js, fjs);
  })(window, document, 'script', '_hw', widgetURL);
}
